import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './AddPayoutContainer.css';
import { Grid, Row, Col } from 'react-bootstrap';

// Components
import AccountSettingsSideMenu from '../../components/AccountSettingsSideMenu';
import PayoutForm from '../../components/Payout/PayoutForm';

const AddPayoutContainer = ({ initialData }) => {

  return (
    <>
      <Grid fluid className={'dashBoardContainer'}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'dashBoardListingGrid'}>
              <AccountSettingsSideMenu />
              <PayoutForm initialValues={initialData} />
            </div>
          </Col>
        </Row>
      </Grid>
    </>
  );
}


AddPayoutContainer.propTypes = {
  initialData: PropTypes.object.isRequired
};

export default withStyles(s)(AddPayoutContainer);
